import acquiring from './acquiring.svg';
import api_v1 from './api_v1.svg';
import api_v2 from './api_v2.svg';
import arrow_v1 from './arrow_v1.svg';
import arrow_v2 from './arrow_v2.svg';
import bank_v1 from './bank_v1.svg';
import bank_v2 from './bank_v2.svg';
import bike from './bike.svg';
import book_v1 from './book_v1.svg';
import book_v2 from './book_v2.svg';
import business_center_v1 from './business_center_v1.svg';
import business_center_v2 from './business_center_v2.svg';
import calendar from './calendar.svg';
import campaign_v1 from './campaign_v1.svg';
import campaign_v2 from './campaign_v2.svg';
import card_acquiring from './card_acquiring.svg';
import card_issuing from './card_issuing.svg';
import card_v1 from './card_v1.svg';
import card_v2 from './card_v2.svg';
import chat_v1 from './chat_v1.svg';
import chat_v2 from './chat_v2.svg';
import check_cashing from './check_cashing.svg';
import check_circle_v1 from './check_circle_v1.svg';
import check_circle_v2 from './check_circle_v2.svg';
import code_v1 from './code_v1.svg';
import code_v2 from './code_v2.svg';
import contactless_payment from './contactless_payment.svg';
import desktop from './desktop.svg';
import dissatisfied_v1 from './dissatisfied_v1.svg';
import dissatisfied_v2 from './dissatisfied_v2.svg';
import document_v1 from './document_v1.svg';
import document_v2 from './document_v2.svg';
import electric_scooter_v1 from './electric_scooter_v1.svg';
import electric_scooter_v2 from './electric_scooter_v2.svg';
import enterprise from './enterprise.svg';
import euro from './euro.svg';
import filters from './filters.svg';
import gavel_v1 from './gavel_v1.svg';
import gavel_v2 from './gavel_v2.svg';
import globe_v1 from './globe_v1.svg';
import globe_v2 from './globe_v2.svg';
import government_v1 from './government_v1.svg';
import government_v2 from './government_v2.svg';
import group from './group.svg';
import help_center_v1 from './help_center_v1.svg';
import help_center_v2 from './help_center_v2.svg';
import hub from './hub.svg';
import innovation_v1 from './innovation_v1.svg';
import innovation_v2 from './innovation_v2.svg';
import international_transfers from './international_transfers.svg';
import kyc from './kyc.svg';
import launch_v1 from './launch_v1.svg';
import launch_v2 from './launch_v2.svg';
import lock_v1 from './lock_v1.svg';
import lock_v2 from './lock_v2.svg';
import lunch_card_v1 from './lunch_card_v1.svg';
import lunch_card_v2 from './lunch_card_v2.svg';
import mail from './mail.svg';
import message_v1 from './message_v1.svg';
import message_v2 from './message_v2.svg';
import mobility_v1 from './mobility_v1.svg';
import mobility_v2 from './mobility_v2.svg';
import needs_v1 from './needs_v1.svg';
import needs_v2 from './needs_v2.svg';
import neutral_v1 from './neutral_v1.svg';
import neutral_v2 from './neutral_v2.svg';
import no_transaction from './no_transaction.svg';
import non_governmental_organization from './non_governmental_organization.svg';
import operation from './operation.svg';
import organigram_child from './organigram_child.svg';
import organigram_parent from './organigram_parent.svg';
import organigram from './organigram.svg';
import parent_child_child from './parent_child_child.svg';
import parent_child from './parent_child.svg';
import payment_accounts from './payment_accounts.svg';
import priority_high from './priority_high.svg';
import question from './question.svg';
import restaurant_v1 from './restaurant_v1.svg';
import restaurant_v2 from './restaurant_v2.svg';
import safe from './safe.svg';
import satisfied_v1 from './satisfied_v1.svg';
import satisfied_v2 from './satisfied_v2.svg';
import scooter_v1 from './scooter_v1.svg';
import scooter_v2 from './scooter_v2.svg';
import screen_v1 from './screen_v1.svg';
import screen_v2 from './screen_v2.svg';
import search_v1 from './search_v1.svg';
import search_v2 from './search_v2.svg';
import settings_v1 from './settings_v1.svg';
import settings_v2 from './settings_v2.svg';
import smartphone_v1 from './smartphone_v1.svg';
import smartphone_v2 from './smartphone_v2.svg';
import speed_v1 from './speed_v1.svg';
import speed_v2 from './speed_v2.svg';
import support_agent_v1 from './support_agent_v1.svg';
import support_agent_v2 from './support_agent_v2.svg';
import sync from './sync.svg';
import target_v1 from './target_v1.svg';
import target_v2 from './target_v2.svg';
import technical_documentation_v1 from './technical_documentation_v1.svg';
import technical_documentation_v2 from './technical_documentation_v2.svg';
import terminal from './terminal.svg';
import train_v1 from './train_v1.svg';
import train_v2 from './train_v2.svg';
import tram_v1 from './tram_v1.svg';
import tram_v2 from './tram_v2.svg';
import trending_down_v1 from './trending_down_v1.svg';
import trending_down_v2 from './trending_down_v2.svg';
import trending_up_v1 from './trending_up_v1.svg';
import trending_up_v2 from './trending_up_v2.svg';
import user_experience_v1 from './user_experience_v1.svg';
import user_experience_v2 from './user_experience_v2.svg';
import user_star from './user_star.svg';
import user from './user.svg';
import verified_content_v1 from './verified_content_v1.svg';
import verified_content_v2 from './verified_content_v2.svg';
import verified_id from './verified_id.svg';
import verified_v1 from './verified_v1.svg';
import verified_v2 from './verified_v2.svg';
import very_satisfied_v1 from './very_satisfied_v1.svg';
import very_satisfied_v2 from './very_satisfied_v2.svg';
import wallet_v1 from './wallet_v1.svg';
import wallet_v2 from './wallet_v2.svg';
import warning_v1 from './warning_v1.svg';
import warning_v2 from './warning_v2.svg';
import xpay_v1 from './xpay_v1.svg';
import xpay_v2 from './xpay_v2.svg';

// svgDictionary
export const defaultSvgs = {
  acquiring,
  api_v1,
  api_v2,
  arrow_v1,
  arrow_v2,
  bank_v1,
  bank_v2,
  bike,
  book_v1,
  book_v2,
  business_center_v1,
  business_center_v2,
  calendar,
  campaign_v1,
  campaign_v2,
  card_acquiring,
  card_issuing,
  card_v1,
  card_v2,
  chat_v1,
  chat_v2,
  check_cashing,
  check_circle_v1,
  check_circle_v2,
  code_v1,
  code_v2,
  contactless_payment,
  desktop,
  dissatisfied_v1,
  dissatisfied_v2,
  document_v1,
  document_v2,
  electric_scooter_v1,
  electric_scooter_v2,
  enterprise,
  euro,
  filters,
  gavel_v1,
  gavel_v2,
  globe_v1,
  globe_v2,
  government_v1,
  government_v2,
  group,
  help_center_v1,
  help_center_v2,
  hub,
  innovation_v1,
  innovation_v2,
  international_transfers,
  kyc,
  launch_v1,
  launch_v2,
  lock_v1,
  lock_v2,
  lunch_card_v1,
  lunch_card_v2,
  mail,
  message_v1,
  message_v2,
  mobility_v1,
  mobility_v2,
  needs_v1,
  needs_v2,
  neutral_v1,
  neutral_v2,
  no_transaction_v1: no_transaction,
  no_transaction_v2: no_transaction,
  non_governmental_organization,
  operation_v1: operation,
  operation_v2: operation,
  organigram,
  organigram_child,
  organigram_parent,
  parent_child,
  parent_child_child,
  payment_accounts,
  priority_high_v1: priority_high,
  priority_high_v2: priority_high,
  question_v1: question,
  question_v2: question,
  restaurant_v1,
  restaurant_v2,
  safe,
  satisfied_v1,
  satisfied_v2,
  scooter_v1,
  scooter_v2,
  screen_v1,
  screen_v2,
  search_v1,
  search_v2,
  settings_v1,
  settings_v2,
  smartphone_v1,
  smartphone_v2,
  speed_v1,
  speed_v2,
  support_agent_v1,
  support_agent_v2,
  sync,
  target_v1,
  target_v2,
  technical_documentation_v1,
  technical_documentation_v2,
  terminal,
  train_v1,
  train_v2,
  tram_v1,
  tram_v2,
  trending_down_v1,
  trending_down_v2,
  trending_up_v1,
  trending_up_v2,
  user,
  user_experience_v1,
  user_experience_v2,
  user_star,
  verified_content_v1,
  verified_content_v2,
  verified_id,
  verified_v1,
  verified_v2,
  very_satisfied_v1,
  very_satisfied_v2,
  wallet_v1,
  wallet_v2,
  warning_v1,
  warning_v2,
  xpay_v1,
  xpay_v2,
};
